import React, { useEffect, useState } from "react"
import "./ProductsRecommendations.css"
import { useDispatch, useSelector } from "react-redux"
import ProductCard from "../ProductCard/ProductCard"
import Slider from "react-slick"
import axios from "axios"

import Utils from "../../utils/Utils"
import { SetImgPrefix, SetUrlPrefix } from "../../state/actions"

const ProductsRecommendations = (props) => {
  const { recommendation } = props
  const display = useSelector((state) => state.config.display)
  const isMobile = useSelector((state) => state.isMobile)
  const config = useSelector((state) => state.config)

  const settings = {
    dots: false,
    infinite: false,
    speed: 200,
    slidesToShow: isMobile || display === "half-screen" ? 2 : 4,
    slidesToScroll: isMobile || display === "half-screen" ? 2 : 4,
  }

  const [products, setProducts] = useState([])
  const [showRec, setShowRec] = useState(true)

  const dispatch = useDispatch()
  useEffect(() => {
    if (recommendation?.recommender?.recommender?.type === "custom") {
      dispatch(SetUrlPrefix(window.location.origin))
      setProducts(recommendation?.recommender?.recommender?.content?.products)
    } else {
      const recUrl =  config?.baseUrl + `/API/shops/${ config?.shopId}/recommend/${recommendation?.id}`

      axios
        .get(recUrl)
        .then((res) => {
          if (res?.data?.items?.length > 0) {
            setProducts(res?.data?.items)
          } else {
            setShowRec(false)
          }
        })
    }
  }, [recommendation])

  function parseProduct(prod) {
    if (prod?.data) {
      if (!prod?.data?.image) {
        const newImage = prod?.image?.map((img) => img?.url)
        return { ...prod, data: { ...prod?.data, image: newImage } }
      }
      return prod
    }
    return {
      data: { ...prod, image: [prod.image] },
      pricing: { sellingPrice: prod?.price, listingPrice: prod?.price },
      header: {
        id: prod?.id,
      },
    }
  }
  if (!showRec) {
    return <></>
  }
  return (
    <div className="products-recommendations">
      <div className="label "> Trending Products </div>
      <Slider {...settings}>
        {products.map((item, index) => (
          <ProductCard
            value={parseProduct(item?.item ?? item)}
            key={"product_" + index}
          />
        ))}
      </Slider>
    </div>
  )
}

export default ProductsRecommendations
